import {
  ProductBuilderMachineContext,
  ProductWithMeasurementsRequestBody,
} from '../types';
import {
  getCurrentVariant,
  getCurrentVariantRollerNight,
} from './getCurrentVariant';
import { isCurtain } from './isCurtain';

type GetProductWithMeasurementsRequestBody = (
  context: ProductBuilderMachineContext,
) => ProductWithMeasurementsRequestBody;

export const getProductWithMeasurementsRequestBody: GetProductWithMeasurementsRequestBody = context => {
  const configuration: string = context.custom.configuration || '';
  const measurements: string | undefined = context.custom.measurements;
  if (!measurements) throw new Error(`No measurements.`);

  let [width, height] = measurements.split('x').map(value => parseInt(value));
  if (!width || !height) throw new Error(`Invalid measurements`);

  // Check if this is a curtain product
  const isCurtainType = isCurtain(context);

  // Only divide width by 2 for Centre Opening if it's NOT a curtain
  // Curtains handle Centre Opening differently - they use the full width
  if (configuration.includes('Centre Opening') && !isCurtainType) {
    // Make sure if centre opening is selected it comes to a whole number
    width = Math.round(width / 2);
  }

  const variant = getCurrentVariant(context);

  const nightVariant =
    window.location.pathname.includes('roller-day-night') === true
      ? getCurrentVariantRollerNight(context)
      : null;

  if (!variant) throw new Error(`Could not get current variant.`);

  const baseProduct = context.products.filter(product =>
    product.variants.some(baseVariant => baseVariant.id === variant.id),
  );
  const customBlindSize = (width * height) / 1000000;

  if (
    baseProduct[0].metafields.max_sqm &&
    Number(baseProduct[0].metafields.max_sqm) > 0 &&
    customBlindSize > Number(baseProduct[0].metafields.max_sqm)
  ) {
    throw new Error(`Product exceeds the maximum square metre size.`);
  }

  // update max width when user select smartglide
  let driveControlSmartglide = false;
  if (context.custom.driveControl) {
    driveControlSmartglide = context.custom.driveControl.includes('Smartglide');
  }
  const baseProductMaxwidth =
    window.location.pathname.includes('roller') === true &&
    driveControlSmartglide === true &&
    baseProduct[0].metafields.max_width &&
    baseProduct[0].metafields.roller_smart_glide_max_width &&
    baseProduct[0].metafields.max_width >
      baseProduct[0].metafields.roller_smart_glide_max_width
      ? baseProduct[0].metafields.roller_smart_glide_max_width
      : window.location.pathname.includes('roller-day-night') &&
        baseProduct[0].metafields.max_width &&
        baseProduct[0].metafields.roller_day_night_max_width &&
        baseProduct[0].metafields.max_width >
          baseProduct[0].metafields.roller_day_night_max_width
      ? baseProduct[0].metafields.roller_day_night_max_width
      : baseProduct[0].metafields.max_width;

  const isMeasurmentInvalid = 
    (baseProduct[0].handle.includes("roller-blind")
      && baseProduct[0].title.includes("Chainless")) ? (
      width && height &&
      isWidthInRange(width, height)
    ) : 
    (baseProduct[0].metafields.min_width &&
      Number(baseProduct[0].metafields.min_width) > 0 &&
      width < Number(baseProduct[0].metafields.min_width)) ||
    (baseProductMaxwidth &&
      Number(baseProductMaxwidth) > 0 &&
      width > Number(baseProductMaxwidth)) ||
    (baseProduct[0].metafields.min_height &&
      Number(baseProduct[0].metafields.min_height) > 0 &&
      height < Number(baseProduct[0].metafields.min_height)) ||
    (baseProduct[0].metafields.max_height &&
      Number(baseProduct[0].metafields.max_height) > 0 &&
      height > Number(baseProduct[0].metafields.max_height));

  function isWidthInRange(width: number, height: number) {
    let isInRange = true
    baseProduct[0]?.metafields?.max_width_range?.map((widths, i) => {
      const [min, max] = widths.split('-');
      if (width >= Number(min) && width <= Number(max)) {
        if (Number(height) <= Number(baseProduct[0]?.metafields?.max_height_range?.[i])) {
          isInRange = false
        }
      }
    })
    return isInRange
  }

  if (isMeasurmentInvalid) {
    throw new Error(`Product measurements  are not valid.`);
  }

  if (nightVariant && nightVariant.id) {
    return {
      data: [
        {
          type: 'product_variant',
          attributes: {
            base_variant_id: variant.id,
            width,
            height,
          },
        },
        {
          type: 'product_variant',
          attributes: {
            base_variant_id: nightVariant.id,
            width,
            height,
          },
        },
      ],
    };
  } else {
  }

  return {
    data: [
      {
        type: 'product_variant',
        attributes: {
          base_variant_id: variant.id,
          width,
          height,
        },
      },
    ],
  };
};
